module.exports = __webpack_public_path__ + "static/media/avatar.86cb1716.jpeg";